module.exports = __webpack_public_path__ + "static/media/apartment13.c9633c5b.jpg";